import { InjectionToken } from '@angular/core';
import { HttpContextToken } from '@angular/common/http';

import { type AuthSession } from './types';

export const REQUIRES_AUTH = new HttpContextToken<boolean>(() => true);

export const ALLOW_REFRESH = new HttpContextToken<boolean>(() => true);

export const SKIP_BASE_URL = new HttpContextToken<boolean>(() => false);

export const SKIP_API_ENVELOPE_UNWRAP = new HttpContextToken<boolean>(() => false);

export const AUTH_SESSION = new InjectionToken<AuthSession>('AuthSession');
